module.exports = "/img/car-gallery-right.0058ba3f.png";